"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrontendUpdateTrackerProvider = void 0;
const SERVICE_NOT_INITIALIZED_ERROR = 'FrontendUpdateTracker is not initialized';
class FrontendUpdateTrackerProvider {
    static get frontendUpdateTracker() {
        if (!window.frontendUpdateTracker) {
            throw new Error(SERVICE_NOT_INITIALIZED_ERROR);
        }
        return window.frontendUpdateTracker;
    }
}
exports.FrontendUpdateTrackerProvider = FrontendUpdateTrackerProvider;
